// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.order.eyefinity.OrderEyefinityFeeLensResponse */
/* istanbul ignore next */
@GandalfModel
export class OrderEyefinityFeeLensResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	eyefinityFeeLensId!: number | null;

	@GandalfProperty({ designType: String })
	hcpcsCode!: string | null;

	@GandalfProperty({ designType: String })
	name!: string | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	retailCost!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	serviceFee!: number | null;

}
